import { GetStaticPaths, GetStaticProps } from 'next';
import { PRODUCT_TYPE } from '@ahmdigital/constants';

import { ByocNavigationProvider } from '../../../../src/client/pages/build-your-cover/context/byoc-navigation-context';
import {
  COMMON_STEPS,
  JOURNEY_STEPS,
  JOURNEY_TYPE_URL_SLUG,
  URL_SLUG_TO_JOURNEY_TYPE,
} from '../../../../src/client/pages/build-your-cover/constants';
import BuildYourCover from '../../../../src/client/pages/build-your-cover';
import StepGuard from '../../../../src/client/pages/build-your-cover/components/step-guard';
import type { JourneyProductType, StepSlug } from '../../../../src/client/pages/build-your-cover/types';

type StepPageProps = {
  journeyType: JourneyProductType;
  step: StepSlug;
};

export const getStaticPaths: GetStaticPaths = () => {
  const journeyTypes = Object.keys(JOURNEY_STEPS) as JourneyProductType[];

  const commonPaths = COMMON_STEPS.map((step) => ({ params: { slug: [step] } }));
  const journeyPaths = journeyTypes.flatMap((type) =>
    JOURNEY_STEPS[type].map((step) => ({ params: { slug: [JOURNEY_TYPE_URL_SLUG[type], step] } })),
  );

  return {
    fallback: false,
    paths: [...commonPaths, ...journeyPaths],
  };
};

export const getStaticProps: GetStaticProps<StepPageProps> = ({ params }) => {
  const [step, urlSlug] = (params?.slug as string[]).reverse() as [StepSlug, string | undefined];
  const journeyType: JourneyProductType = urlSlug ? URL_SLUG_TO_JOURNEY_TYPE[urlSlug]! : PRODUCT_TYPE.PACKAGE;

  return { props: { journeyType, step } };
};

export default function StepPage({ journeyType, step }: StepPageProps) {
  return (
    <ByocNavigationProvider activeSlug={step} journeyType={journeyType}>
      <StepGuard>
        <BuildYourCover />
      </StepGuard>
    </ByocNavigationProvider>
  );
}
